import { useContext } from 'react'

import Image from "next/legacy/image"
import iconTicket from '../../../../images/icons/tickets.svg'
import iconExpress from '../../../../images/icons/express.svg'
import iconExtras from '../../../../images/icons/extras.svg'

import { format, parseISO } from 'date-fns'

import { CartContext } from '../../../../contexts/CartContext'
import { CartTicket } from '../../../../types/CartType'
import { getCartTicketCategory } from '../../../../utils/cartUtils'
import { CartQuantityPicker } from '../../CartQuantityPicker/CartQuantityPicker'
import { formatPrice } from '../../../../utils/pricingUtils'

import styles from './CartListItem.module.scss'

type CartListItem = {
  tickets: Array<CartTicket>,
  remove: (ticketIds: Array<string>, dateStr?: string) => void,
}

export function CartListItem({ tickets, remove }: CartListItem) {
  const { cart, cartAPI } = useContext(CartContext)

  const firstTicket = tickets[0]

  const qtyPickers: Array<JSX.Element> = []

  let ticketInfo = null
  let searchInfo = null
  let dateInfo = null
  let icon = <Image alt="icon" src={iconExtras} width="30"/>


  switch (getCartTicketCategory(firstTicket)) {

    case "tickets":
      let parks = 'Universal Studios + Islands of Adventure'
      if (firstTicket.title.includes('3 Park')) parks += ' + Volcano Bay'
      if (firstTicket.title.includes('Epic')) parks += ' + Epic Universe'
      if (firstTicket.title.includes('All Parks')) parks += ' + Volcano Bay + Epic Universe'
      ticketInfo = <div className={styles.ticketInfo}>{ parks }</div>
      // Checking if date attribute (5) exists
      if (Object.keys(firstTicket.attributes).includes('5')) {
        dateInfo = <div className={styles.dateInfo}>{ format(new Date(firstTicket.attributes['5'][0]),'MMMM d, yyyy') }</div>
      } else {
        dateInfo = <div className={styles.dateInfo}>{ `Can be activated on any date in ${firstTicket.year}` }</div>
      }
      icon = <Image alt="ticket" src={iconTicket} width="30"/>
      break;

    case "expressPasses":
      dateInfo = <div className={styles.dateInfo}>{ format(parseISO(firstTicket.date), 'MMMM d, yyyy') }</div>
      icon = <Image alt="express-pass" src={iconExpress} width="30"/>
      break;

    case "extras":
      dateInfo = <div className={styles.dateInfo}>{ format(parseISO(firstTicket.date), 'MMMM d, yyyy') }</div>
      break;
  }

  for (const ticket of tickets) {
    qtyPickers.push(<CartQuantityPicker key={ticket.cart_item_id} type={getCartTicketCategory(firstTicket)} ticketPrice={ticket.price} showTicketPrice={false} showTotalPrice={true} qty={ticket.qty} setQty={(qty: number) => cartAPI?.setQty(ticket.cart_item_id, qty)} loading={cart?.loading ?? false} leftText={ticket.data?.type_ticket ?? ''} leftSubText={getCartTicketCategory(firstTicket) === 'rooms' ? `(£${formatPrice(ticket.price)} per room)` : `(£${formatPrice(ticket.price)} per ticket)`} />)
  }

  const removeLink = <a className={styles.remove} onClick={() => remove(tickets.map(t => t.ticket_id), firstTicket.date)}>Remove</a>

  return (
    <div className={styles.cartListItem}>
      <div className={styles.icon}>
        { icon }
      </div>
      <div className={styles.info}>
        <h2>{ firstTicket.title }</h2>
        { ticketInfo }
        { searchInfo }
        { dateInfo }
        { removeLink }
      </div>
      <div className={styles.qty}>
        { qtyPickers }
      </div>
    </div>
  )
}

